import { StringFilter } from "./string-filter";

export class OrdInspectionRequestTaskFilter {
    public name?: StringFilter;
}
